<fe-header></fe-header>
<main>
    <fe-promotion-hero [promotion]="promotion"></fe-promotion-hero>
    <fe-promotion-offer></fe-promotion-offer>
    <fe-promotion-reasons></fe-promotion-reasons>
    <fe-promotion-terms
        [terms]="promotion?.termsAndConditions"
    ></fe-promotion-terms>

    <div class="container">
        <div
            class="newsletter-container d-flex flex-md-row flex-column row align-items-center"
        >
            <div
                class="col-12 col-md-2 d-flex justify-content-center justify-content-md-start"
            >
                <img
                    alt="newsletter"
                    [src]="'images/register-mail.webp' | cdn"
                />
            </div>
            <div class="col-12 col-md-5">
                <h2 class="title-newsletter">
                    {{
                        'fe_promotions_newsletter_h2_title_register' | translate
                    }}
                </h2>
            </div>
            <form
                [formGroup]="newsLetterForm"
                class="col-12 col-md-5"
                id="register-email"
                *ngIf="!suscribed"
            >
                <p class="form-advice">
                    {{
                        'fe_promotions_newsletter_form_span_description'
                            | translate
                    }}
                </p>
                <div class="row gy-14">
                    <div>
                        <fe-input
                            class="mb-10"
                            [label]="
                                'fe_promotions_newsletter_form_email_placeholder'
                                    | translate
                            "
                            [type]="'email'"
                            [formControlName]="'email'"
                            name="email"
                            id="email"
                        ></fe-input>
                    </div>
                </div>
                <div class="row gy-14">
                    <div>
                        <fe-button
                            class="d-grid"
                            [style]="'tertiary'"
                            [btnClass]="'border-0'"
                            (click)="onclickSuscribe()"
                            [loading]="loadingBtnSearch"
                            >{{
                                'fe_promotions_newsletter_form_button_send'
                                    | translate
                            }}</fe-button
                        >
                    </div>
                </div>
            </form>

            <div class="suscribe__complete col-md-5" *ngIf="suscribed">
                <h2 class="succes_suscribe_title">
                    {{
                        'fe_promotions_newsletter_h2_title_register_success'
                            | translate
                    }}
                </h2>
                <p class="succes_suscribe_description">
                    {{
                        'fe_promotions_newsletter_p_description_register_success'
                            | translate
                    }}
                </p>
            </div>
        </div>
    </div>
</main>
<fe-footer></fe-footer>
